import { render, staticRenderFns } from "./FormCaregiver.vue?vue&type=template&id=838d9df8&scoped=true&lang=pug"
import script from "./FormCaregiver.vue?vue&type=script&lang=js"
export * from "./FormCaregiver.vue?vue&type=script&lang=js"
import style0 from "./FormCaregiver.vue?vue&type=style&index=0&id=838d9df8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838d9df8",
  null
  
)

export default component.exports